import { alpha, Theme } from '@mui/material'

export const LAST_YEAR_SERIES = 'last-year-series'
export const THIS_YEAR_SERIES = 'this-year-series'

export const getChartColors = (theme: Theme) => {
  return {
    primaryColor: theme.palette.tertiary.main,
    secondaryColor: theme.palette.info.main,
    textColor: theme.palette.text.secondary,
  }
}

export const formatSalesValue = (value: number | null) => {
  if (value === null) return ''
  if (value >= 1000000) return `${(value / 1000000).toFixed(1)}m`
  if (value >= 1000) return `${(value / 1000).toFixed(0)}k`
  return value.toString()
}

export const getCommonYaxisProps = ({
  color,
  max,
  textColor,
}: {
  color: string
  max: number
  textColor: string
}) =>
  ({
    min: 0,
    max,
    colorMap: {
      type: 'continuous',
      min: 0,
      max,
      color: ['transparent', alpha(color, 0.3)],
    },
    valueFormatter: formatSalesValue,
    tickLabelStyle: { fill: textColor },
    disableLine: true,
    disableTicks: true,
    tickLabelInterval: (value: number) => value !== 0,
    tickLabelPlacement: 'tick',
  }) as const
